import { css } from "lit"

export const CONTAINER = css`
  .container {
    max-width: 1200px;
    margin: 0 auto;
  }
`
